import * as React from "react";
import { IconProps } from "../types";

const SidebarLeftShowOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <line
          x1="6.25"
          y1="2.75"
          x2="6.25"
          y2="15.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polyline
          points="10.25 6.5 12.75 9 10.25 11.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="1.75"
          y="2.75"
          width="14.5"
          height="12.5"
          rx="2"
          ry="2"
          transform="translate(18 18) rotate(180)"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default SidebarLeftShowOutlineIcon;
